module.exports = __webpack_public_path__ + "img/battery-charging-02.362b7665.svg";